module.exports = __webpack_public_path__ + "img/Ford-oval-sm.70d9b2e9.png";